import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetFailureDropdownsRequest = (type) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FailuresTracker/GetFailureDropdowns`,
	params: { type }
});

export const AddDropdownFieldRequest = (userId, name, value, relations) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}FailuresTracker/AddDropdownField`,
	data: { userId, name, value, relations }
});

export const RemoveDropdownFieldRequest = (userId, name, value, id, relations) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}FailuresTracker/RemoveDropdownField`,
	data: { userId, name, value, id, relations }
});
